'use client'

import { Checkbox } from 'form-components/components/Checkbox/Checkbox'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

import type { SubscriptionCheckboxProps } from '../../types/checkbox'

export enum NewsletterSubscriptionLabelKeySufix {
	NoDiscount = 'nodiscount',
	Discount = '10discount',
}

export function RegistryCheckbox(
	checkboxProps: Readonly<SubscriptionCheckboxProps>
) {
	const {
		country: { hasDiscount },
	} = useMasterData()
	const { t } = useLabels()
	const labelKeyDiscountSufix = hasDiscount
		? NewsletterSubscriptionLabelKeySufix.Discount
		: NewsletterSubscriptionLabelKeySufix.NoDiscount

	return (
		<Checkbox
			label={t(`createAccount.promotions.checkbox.${labelKeyDiscountSufix}`)}
			{...checkboxProps}
		/>
	)
}
